<template>
  <div
    class="popup modal"
    :class="{active: props.isActive}"
  >
    <div class="popup__body">
      <div
        class="popup__content"
        :class="{maxHeight: props.classHeight === 'max', maxWidth: props.classWidth === 'max'}"
        :style="{maxWidth: props.maxWidth, height: props.height}"
      >
        <slot />
        <div
          v-if="props.closeButton"
          class="popup__close"
          @click="$emit('update:isActive', false)"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18"
              stroke="#A7A7A7"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6 6L18 18"
              stroke="#A7A7A7"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
    <div
      class="dark"
      @click.stop.self="emit('update:isActive', false)"
    />
  </div>
</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps({
  isActive: {
    type: Boolean,
    required: true
  },
  name: {
    type: String,
    required: false,
    default: () => ""
  },
  maxWidth: {
    type: String,
    required: false,
    default: () => ""
  },
  height: {
    type: String,
    required: false,
    default: () => ""
  },
  classHeight: {
    type: String,
    required: false,
    default: () => ""
  },
  classWidth: {
    type: String,
    required: false,
    default: () => ""
  },
  closeButton: {
    type: Boolean,
    required: false,
    default: true
  }
});

const emit = defineEmits(["update:isActive"]);

</script>



<style lang="scss" scoped>
.popup {
  z-index: 2000;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  overflow-x: hidden;
  // display: none;
  pointer-events: none;
  opacity: 0;
  &.active {
    //   display: block;
    z-index: 2000;
    pointer-events: all;
    opacity: 1;
  }
  & .dark {
    content: "";
    background: #000000;
    opacity: 0.7;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 104;
  }
  &__close {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    right: 30px;
    top: 30px;
  }

}
.popup__content {
  position: relative;
  background: var(--var-popup-bg);
  border-radius: 10px;
  padding: 20px;
  width: 95%;
  max-width: 715px;
  z-index: 2000;
  background: #fff;
  &.maxHeight {
    height: calc(100vh - 60px);
  }
  &.maxWidth {
    max-width: 100%;
  }
  @media (max-width: 539px) {
    padding: 35px 15px 38px;
  }
}
.popup__body {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 10px;
  min-height: 100%;
}
</style>